import { api, ConsumptionAggregate, TopRecipe, escapeHtml, renderError } from "../api.js";

export async function renderStats (root: HTMLElement): Promise<void> {
    const title = document.createElement ("h2");
    title.textContent = "Statistiken";
    root.appendChild (title);

    const hint = document.createElement ("div");
    hint.className = "muted";
    hint.textContent = "Durchschnitt pro Tag in den letzten 7/30/90 Tagen + meistgegessene Rezepte.";
    hint.style.marginBottom = "1rem";
    root.appendChild (hint);

    const card = document.createElement ("sl-card");
    const wrap = document.createElement ("div");
    wrap.innerHTML = "<sl-spinner></sl-spinner>";
    card.appendChild (wrap);
    root.appendChild (card);

    const topCard = document.createElement ("sl-card");
    topCard.style.marginTop = "1rem";
    const topWrap = document.createElement ("div");
    topWrap.innerHTML = "<sl-spinner></sl-spinner>";
    topCard.appendChild (topWrap);
    root.appendChild (topCard);

    const now = new Date ();
    const tomorrow = new Date (now);
    tomorrow.setDate (now.getDate () + 1);
    tomorrow.setHours (0, 0, 0, 0);

    const range = (days: number): [number, number] => {
        const start = new Date (tomorrow);
        start.setDate (start.getDate () - days);
        return [Math.floor (start.getTime () / 1000), Math.floor (tomorrow.getTime () / 1000)];
    };

    try {
        const [a7, a30, a90] = await Promise.all ([
            api.aggregateConsumption (...range (7)),
            api.aggregateConsumption (...range (30)),
            api.aggregateConsumption (...range (90)),
        ]);

        const fmt = (n: number) => Number.isInteger (n) ? String (n) : n.toFixed (1);
        const avgRow = (label: string, agg: ConsumptionAggregate, days: number) => `<tr>
            <td>${label}</td>
            <td style="text-align:right">${Math.round (agg.kcal_total / days)} kcal</td>
            <td style="text-align:right">${fmt (agg.protein_total / days)} g</td>
            <td style="text-align:right">${fmt (agg.fat_total / days)} g</td>
            <td style="text-align:right">${fmt (agg.sugar_total / days)} g</td>
            <td style="text-align:right">${Math.round ((agg.drink_volume_ml_total ?? 0) / days)} ml</td>
            <td style="text-align:right">${(agg.entry_count / days).toFixed (1)}</td>
        </tr>`;

        wrap.innerHTML = `<strong>Durchschnitt pro Tag</strong>
        <table class="totals" style="width:100%;margin-top:0.5rem;">
            <thead><tr>
                <th style="text-align:left">Zeitraum</th>
                <th style="text-align:right">kcal</th>
                <th style="text-align:right">Eiweiss</th>
                <th style="text-align:right">Fett</th>
                <th style="text-align:right">Zucker</th>
                <th style="text-align:right">Trinken</th>
                <th style="text-align:right">Eintraege</th>
            </tr></thead>
            <tbody>
                ${avgRow ("7 Tage", a7, 7)}
                ${avgRow ("30 Tage", a30, 30)}
                ${avgRow ("90 Tage", a90, 90)}
            </tbody>
        </table>`;
    }
    catch (err) {
        renderError (wrap, err);
    }

    try {
        const top30: TopRecipe[] = await api.topRecipes (...range (30));
        if (top30.length === 0) {
            topWrap.innerHTML = `<strong>Top-Rezepte (30 Tage)</strong><div class="muted">Noch keine Eintraege.</div>`;
            return;
        }
        const max = top30[0].use_count;
        let html = `<strong>Top-Rezepte (30 Tage)</strong><table class="totals" style="width:100%;margin-top:0.5rem;"><tbody>`;
        for (const r of top30) {
            const pct = Math.round ((r.use_count / max) * 100);
            html += `<tr>
                <td>${escapeHtml (r.recipe_name)}</td>
                <td style="width:55%"><div style="background:var(--sl-color-primary-100,#dbeafe);border-radius:3px;height:14px;width:${pct}%"></div></td>
                <td style="text-align:right">${r.use_count}x</td>
            </tr>`;
        }
        html += "</tbody></table>";
        topWrap.innerHTML = html;
    }
    catch (err) {
        renderError (topWrap, err);
    }
}

